import { OverlaySpinner } from '@ankr.com/ui';
import loadable from '@loadable/component';

import { TFADialog } from 'modules/tfa/components/TFADialog';

const AuthPage = loadable(
  async () => {
    const module = await import('./AuthPage');

    return module.AuthPage;
  },
  { fallback: <OverlaySpinner /> },
);

export const AuthPageContainer = () => {
  return (
    <>
      <AuthPage />
      <TFADialog />
    </>
  );
};
